document.addEventListener('DOMContentLoaded', () => {
    const descriptionDiv = document.getElementById('product-description');
    const elements = descriptionDiv.children;
    const container = document.createElement('div');

    let currentAccordion;
    let currentPanel;
    let hasAccordion = false;
    let initialText = '';
    let foundTitle = false;
    let afterContent = '';
    let processingAfterContent = false;
    let initialContentHandled = false;
    const textItems = [];

    Array.from(elements).forEach((element, index) => {
        const isTitle = element.innerHTML.startsWith('<strong>') && element.innerHTML.endsWith('</strong>') && !element.innerHTML.includes('<strong>Contenido:</strong>');
        const isContent = element.innerHTML.includes('<strong>Contenido:</strong>');

        if (isTitle) {
            hasAccordion = true;
            foundTitle = true;
            processingAfterContent = false;
            if (!initialContentHandled && initialText) {
                const initialTextDiv = document.createElement('div');
                initialTextDiv.classList.add('panel');
                initialTextDiv.innerHTML = initialText;
                container.appendChild(createAccordion('Detalles de producto', initialTextDiv));
                initialText = '';
                initialContentHandled = true;
            }
            currentAccordion = document.createElement('button');
            currentAccordion.classList.add('accordionCustom');
            currentAccordion.innerHTML = element.innerHTML;
            currentAccordion.addEventListener('click', function () {
                this.classList.toggle('active');
                const panel = this.nextElementSibling;
                panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
            });
            container.appendChild(currentAccordion);

            currentPanel = document.createElement('div');
            currentPanel.classList.add('panel');
            container.appendChild(currentPanel);
        } else if (isContent) {
            const contentDiv = document.createElement('div');
            contentDiv.classList.add('text-item');
            contentDiv.innerHTML = element.innerHTML;
            textItems.push(contentDiv);
            processingAfterContent = true;
        } else {
            if (processingAfterContent) {
                afterContent += element.outerHTML;
            } else if (foundTitle) {
                if (currentPanel) {
                    currentPanel.innerHTML += element.outerHTML;
                } else {
                    currentPanel = document.createElement('div');
                    currentPanel.classList.add('panel');
                    currentPanel.innerHTML += element.outerHTML;
                }
            } else {
                initialText += element.outerHTML;
            }
        }

        if (index === elements.length - 1 && afterContent) {
            const afterContentDiv = document.createElement('div');
            afterContentDiv.classList.add('text-item');
            afterContentDiv.innerHTML = afterContent;
            textItems.push(afterContentDiv);
        }
    });

    if (!hasAccordion) {
        const defaultAccordion = document.createElement('button');
        defaultAccordion.classList.add('accordionCustom');
        defaultAccordion.innerHTML = '<strong>Detalles de producto</strong>';
        defaultAccordion.addEventListener('click', function () {
            this.classList.toggle('active');
            const panel = this.nextElementSibling;
            panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
        });
        container.appendChild(defaultAccordion);

        const defaultPanel = document.createElement('div');
        defaultPanel.classList.add('panel');
        defaultPanel.innerHTML = initialText || descriptionDiv.innerHTML;
        container.appendChild(defaultPanel);
    }

    textItems.forEach(item => {
        container.appendChild(item);
    });

    descriptionDiv.innerHTML = '';
    descriptionDiv.appendChild(container);
});

function createAccordion(title, contentDiv) {
    const accordion = document.createElement('button');
    accordion.classList.add('accordionCustom');
    accordion.innerHTML = `<strong>${title}</strong>`;
    accordion.addEventListener('click', function () {
        this.classList.toggle('active');
        const panel = this.nextElementSibling;
        panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
    });

    const panel = document.createElement('div');
    panel.classList.add('panel');
    panel.innerHTML = contentDiv.innerHTML;

    const container = document.createElement('div');
    container.appendChild(accordion);
    container.appendChild(panel);

    return container;
}